
import { defineComponent, onMounted } from 'vue';
import { AppTable, AppCard, AppButton } from '@/components';
import { useBoosterItemList } from '@/modules/booster/model/list';
import { ROUTE_NAME_BOOSTER } from '@/modules/booster/router';
import { Options } from '@/modules/booster/model/mixins';
import { TableColumnType, TableConfig } from '@/components/table/types';

export default defineComponent({
    name: ROUTE_NAME_BOOSTER.INDEX,
    components: { AppTable, AppCard, AppButton },
    setup() {
        const { list, total, query, fetchList, actions } = useBoosterItemList();

        const table: TableConfig = {
            columns: [
                { type: TableColumnType.Index, label: '#' },
                { type: TableColumnType.Text, label: 'Name', key: 'name' },
                { type: TableColumnType.Option, label: 'Type', key: 'type', options: Options.ItemType },
                { type: TableColumnType.Text, label: 'Init value', key: 'initValue' },
                { type: TableColumnType.Text, label: 'Costs', key: 'costs' },
                {
                    type: TableColumnType.Image,
                    label: 'Thumbnail',
                    imageKey: 'thumbnail',
                    statusKey: 'thumbnailStatus'
                },
                { type: TableColumnType.Actions, label: 'Actions' }
            ],
            actions: [
                {
                    props: (row: any) => ({
                        icon: 'fa-edit',
                        theme: 'info',
                        tooltip: 'Edit',
                        to: { name: ROUTE_NAME_BOOSTER.EDIT, params: { type: row.type } }
                    }),
                    canShow: (row: any) => row.canEdit,
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-trash-alt',
                        theme: 'danger',
                        tooltip: 'Delete',
                        disabled: !row.canDelete,
                        onClick: () => actions.remove(row.type)
                    })
                }
            ]
        };

        onMounted(fetchList);

        return { table, list, total, query, fetchList, ROUTE_NAME_BOOSTER };
    }
});
